import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ToastData } from './toast.service';

/**
 * A Toast component shows message with title and close button.
 */
@Component({
  selector: 'toast',
  template: `
        <div class="toast" [ngClass]="[toast.type, toast.theme]">
            <div *ngIf="toast.showClose" class="close-button" (click)="close($event)">
                <button type="button" class="close" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="toast-image" [ngSwitch]="toast.type">
                <ng-template [ngSwitchCase]="'toast-type-info'">
                    <clr-icon shape="info-circle" class="is-info" size="36"></clr-icon>
                </ng-template>
                <ng-template [ngSwitchCase]="'toast-type-success'">
                    <clr-icon shape="check-circle" class="is-success" size="36"></clr-icon>
                </ng-template>
                <ng-template [ngSwitchCase]="'toast-type-wait'">
                    <clr-icon shape="sync" class="is-highlight" size="36"></clr-icon>
                </ng-template>
                <ng-template [ngSwitchCase]="'toast-type-error'">
                    <clr-icon shape="error" class="is-error" size="36"></clr-icon>
                </ng-template>
                <ng-template [ngSwitchCase]="'toast-type-warning'">
                    <clr-icon shape="warning" class="is-warning" size="36"></clr-icon>
                </ng-template>
                <ng-template [ngSwitchCase]="'toast-type-default'">
                    <clr-icon shape="info-circle" size="36"></clr-icon>
                </ng-template>
                <ng-template ngSwitchDefault>
                    <clr-icon shape="info-circle" size="36"></clr-icon>
                </ng-template>
            </div>
            <div *ngIf="toast.title || toast.msg" class="toast-text">
                <span *ngIf="toast.title" class="toast-title">{{toast.title}}</span>
                <br *ngIf="toast.title && toast.msg" />
                <span *ngIf="toast.msg" class="toast-msg">{{toast.msg}}</span>
            </div>
        </div>`,
  styles: [require('./toast.scss')]
})
export class ToastComponent {

  @Input() toast: ToastData;
  @Output('closeToast') closeToastEvent = new EventEmitter();

  /**
   * Event handler invokes when user clicks on close button.
   * This method emit new event into ToastContainer to close it.
   */
  close($event: any) {
    $event.preventDefault();
    this.closeToastEvent.next(this.toast);
  }
}



// WEBPACK FOOTER //
// ./src/common/toasts/toast.component.ts